/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgreementsControllerFindVersionsByTypeQueryResponse, AgreementsControllerFindVersionsByTypePathParams, AgreementsControllerFindVersionsByType401 } from "../../models/agreementsController/AgreementsControllerFindVersionsByType";

function getAgreementsControllerFindVersionsByTypeUrl(type: AgreementsControllerFindVersionsByTypePathParams["type"]) {
  const res = { method: 'GET', url: `/api/v1/agreements/${type}/versions` as const }  
  return res
}

/**
 * @summary Get all versions of an agreement
 * {@link /api/v1/agreements/:type/versions}
 */
export async function agreementsControllerFindVersionsByType(type: AgreementsControllerFindVersionsByTypePathParams["type"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AgreementsControllerFindVersionsByTypeQueryResponse, ResponseErrorConfig<AgreementsControllerFindVersionsByType401>, unknown>({ method : "GET", url : getAgreementsControllerFindVersionsByTypeUrl(type).url.toString(), ... requestConfig })  
  return res.data
}